
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data" class="baseRect">
      <div class="title"><span>基本信息</span></div>
      <van-field
        v-model="data.nickName"
        clearable
        label="昵称"
        placeholder="请输入昵称"
      />
      <van-field
        v-model="data.localName"
        clearable
        label="中文名"
        placeholder="请输入中文名"
      />
      <van-button v-if="data.nickName!==dataSave.nickName || data.localName!==dataSave.localName" :loading="buttonLoading" type="primary" size="large" :color="GetColorMain()" @click="onEditName">提交修改</van-button>
    </div>
    <div v-if="data" class="baseRect">
      <div class="title"><span>绑定信息</span></div>
      <van-field
        v-model="data.lastName"
        clearable
        label="英文姓"
        placeholder="例如zhang"
        readonly
        @click="onBindNameBirthday"
      />
      <van-field
        v-model="data.firstName"
        clearable
        label="英文名"
        placeholder="例如san feng"
        readonly
        @click="onBindNameBirthday"
      />
      <van-field
        v-model="birthday"
        clearable
        label="生日"
        readonly
        @click="onBindNameBirthday"
      />
      <van-field
        v-model="data.email"
        clearable
        label="电子邮箱"
        placeholder="请输入电子邮箱"
        readonly
        @click="onBindNameBirthday"
      />
    </div>
    <div v-if="data" class="baseRect">
      <div class="title"><span>账号信息</span></div>
      <van-field
        v-model="data.userId"
        clearable
        label="会员序号"
        placeholder="请输入昵称"
        readonly
      />
      <van-field
        v-model="createTime"
        clearable
        label="注册日期"
        readonly
      />
    </div>
    <div v-if="data" class="baseRect">
      <div class="title"><span>安全信息</span></div>
      <van-field
        v-model="data.phone"
        clearable
        label="手机"
        placeholder="请输入手机号"
        readonly
        @click="onSafeInfo"
      />

    </div>
    <bindPhone v-model="showBindPhone" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Toast, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import bindPhone from '@/components/bindPhone'
import { formatDate, MyNotify } from '@/utils/base'
import { getUserBase } from '@/utils/base'
import { CheckSystemType } from '@/utils/request'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    TopBar,
    bindPhone
  },
  data() {
    return {
      title: '我的信息',
      backurl: '/my/index',
      data: undefined,
      dataSave: undefined,
      createTime: undefined,
      birthday: undefined,
      buttonLoading: false,
      showBindPhone: false
    }
  },

  created() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    Toast.clear()
    next()
  },
  methods: {
    CheckSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    formatDate,
    init() {
      request({
        url: '/user/getUserBase',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        response.data.nickName = response.data.nickName ? response.data.nickName : ''
        response.data.localName = response.data.localName ? response.data.localName : ''
        this.data = response.data
        this.dataSave = JSON.parse(JSON.stringify(response.data))
        this.createTime = formatDate(response.data.createTime, 'yyyy/MM/dd', true)
        this.birthday = formatDate(response.data.birthday, 'yyyy/MM/dd')
      })
    },
    onBindNameBirthday() {
      this.$router.push('/my/updateNameBirthday')
    },
    onSafeInfo() {
      getUserBase(data => {
        if (!data) {
          MyNotify('info', '获取用户数据失败!')
          return
        }
        if (data.bindPhone) {
          MyNotify('info', '账号已绑定手机,无法重复绑定!')
        } else {
          this.showBindPhone = true
        }
      })
    },
    onEditName() {
      this.buttonLoading = true
      request({
        url: '/user/updateUserNickName',
        method: 'post',
        data: {
          localName: this.data.localName,
          nickName: this.data.nickName
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '昵称/姓名信息修改成功')
        this.init()
      })
    }
  }
}
</script>
<style lang="postcss" scoped>
.baseRect{
  margin: 1em;
  border-radius: 0.5em;
  overflow: hidden;
}
.baseRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.5em 1em;
    background-color: #fff;

}
.baseRect .title span{
    border-bottom: 1px solid #000;
}

</style>
